var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 7,
    viewBox: "0 0 16 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 6.87667H14.8544L11.3267 2.05142V6.87667H10.1406V0.115234H11.3571L14.8138 4.80871V0.115234H15.9999V6.87667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55323 6.87667H7.36719V0.115234H8.55323V6.87667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54798 6.99752C1.55097 6.99752 0 5.57833 0 3.50023C0 1.42212 1.55097 0.00292969 3.54798 0.00292969C4.91649 0.00292969 5.75787 0.712526 6.26472 1.52349L5.25101 2.04048C4.92662 1.48294 4.27785 1.05719 3.54798 1.05719C2.20989 1.05719 1.21645 2.08103 1.21645 3.50023C1.21645 4.91942 2.20989 5.94326 3.54798 5.94326C4.27785 5.94326 4.92662 5.52764 5.25101 4.95997L6.26472 5.47696C5.74773 6.28792 4.91649 6.99752 3.54798 6.99752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCin);
export default __webpack_public_path__ + "static/media/cin.fd463d1c32589f6c22739141f7a4b247.svg";
export { ForwardRef as ReactComponent };